import script from "./ResendActivationEmail.vue?vue&type=script&setup=true&lang=js"
export * from "./ResendActivationEmail.vue?vue&type=script&setup=true&lang=js"

import "./ResendActivationEmail.vue?vue&type=style&index=0&id=3432d593&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3432d593"]])

export default __exports__